// Material-UI Icons
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import CalendarMonthRoundedIcon from "@mui/icons-material/CalendarMonthRounded";
import AnalyticsRoundedIcon from "@mui/icons-material/AnalyticsRounded";
import TuneRoundedIcon from "@mui/icons-material/TuneRounded";
import RequestQuoteRoundedIcon from "@mui/icons-material/RequestQuoteRounded";
import AccountBalanceRoundedIcon from "@mui/icons-material/AccountBalanceRounded";
import FolderRoundedIcon from "@mui/icons-material/FolderRounded";
import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import ListRoundedIcon from "@mui/icons-material/ListRounded";
import ViewQuiltRoundedIcon from "@mui/icons-material/ViewQuiltRounded";
import RuleFolderRoundedIcon from "@mui/icons-material/RuleFolderRounded";
import LowPriorityRoundedIcon from "@mui/icons-material/LowPriorityRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import BusinessRoundedIcon from "@mui/icons-material/BusinessRounded";
import PeopleOutlineRoundedIcon from "@mui/icons-material/PeopleOutlineRounded";
import TaskAltRoundedIcon from "@mui/icons-material/TaskAltRounded";
import AddTaskRoundedIcon from "@mui/icons-material/AddTaskRounded";
import QuestionAnswerRoundedIcon from "@mui/icons-material/QuestionAnswerRounded";
// -------------- CASE TEMPLATE FORM CREATER SIDE PANAL DATA ICONS --------------
import TextFieldsIcon from "@mui/icons-material/TextFields";
import ShortTextIcon from "@mui/icons-material/ShortText";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import ArrowDropDownCircleIcon from "@mui/icons-material/ArrowDropDownCircle";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import PinIcon from "@mui/icons-material/Pin";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PercentIcon from "@mui/icons-material/Percent";
import Filter1Icon from "@mui/icons-material/Filter1";
import Filter9PlusIcon from "@mui/icons-material/Filter9Plus";
import { Box, Typography, Button } from "@mui/material";
import CasesOutlinedIcon from "@mui/icons-material/CasesOutlined";
// export const userData = JSON.parse(localStorage.getItem("UserId"));
// export const lawyerData = JSON.parse(localStorage.getItem("userData"));
// export const profileCompleted = Number(
//   localStorage.getItem("profileCompleted")
// );

export const menuItems = {
  products: [
    { title: "Product Overview", link: "/product1" },
    { title: "Prosecution Manager", link: "/product2" },
    { title: "Lexmom Plus", link: "/product3" },
    { title: "Invention Manager", link: "/product3" },
    { title: "Pricing", link: "/product3" },
    { title: "Free Trial", link: "/product3" },
  ],

  company: [
    { title: "About Us", link: "/about-us" },
    { title: "Why Lexmom", link: "/careers" },
    { title: "Career", link: "/investors" },
    { title: "Blog", link: "/investors" },
    { title: "Forum", link: "/investors" },
    { title: "Testimonials", link: "/investors" },
    { title: "Learning Center", link: "/investors" },
  ],
};

// Extended menu with sub-items
export const DashboardSideMenu = [
  {
    mIcon: <HomeRoundedIcon sx={{ fontSize: "1rem" }} />,
    mText: "Dashboard",
    path: "/dashboard",
    accessId: "sidebar_dashboard",
    planInModule: "",
    // No restrictions - available to all users
  },
  {
    mIcon: <CalendarMonthRoundedIcon sx={{ fontSize: "1rem" }} />,
    mText: "Calendar",
    path: "/dashboard/calendars",
    accessId: "sidebar_calendar",
  },
  {
    mIcon: <TaskAltRoundedIcon sx={{ fontSize: "1rem" }} />,
    mText: "Tasks flow",
    accessId: "sidebar_tasks_flow",
    subMenu: [
      {
        mIcon: <AddTaskRoundedIcon sx={{ fontSize: "1rem" }} />,
        mText: "Tasks",
        path: "/dashboard/tasks",
        accessId: "sidebar_tasks",
      },
      {
        mIcon: <LowPriorityRoundedIcon sx={{ fontSize: "1rem" }} />,
        mText: "Task Template",
        path: "/dashboard/task/template",
        accessId: "sidebar_task_template",
      },
      {
        mIcon: <ListRoundedIcon sx={{ fontSize: "1rem" }} />,
        // mText: "Task Groups",
        mText: "Group Tasks", // by azam sir
        path: "/dashboard/task/group-tasks",
        accessId: "sidebar_task_group_tasks",
      },

      // {
      //   mIcon: <LowPriorityRoundedIcon sx={{ fontSize: "1rem" }} />,
      //   mText: "Task Type",
      //   path: "/dashboard/task/type",
      //   accessId: "sidebar_task_type",
      // },
      // {
      //   mIcon: <HistoryRoundedIcon sx={{ fontSize: "1rem" }} />,
      //   mText: "Task Feed",
      //   path: "/dashboard/tasks/feeds",
      //   accessId: "sidebar_task_feed",
      // },
    ],
  },
  {
    mIcon: <CasesOutlinedIcon sx={{ fontSize: "1rem" }} />,
    mText: "Matters",
    accessId: "sidebar_matters",
    subMenu: [
      {
        mIcon: <CasesOutlinedIcon sx={{ fontSize: "1rem" }} />,
        mText: "All Matters",
        path: "/dashboard/matter",
        accessId: "sidebar_all_matters",
      },
      // {
      //   mIcon: <StairsRoundedIcon sx={{ fontSize: "1rem" }} />,
      //   mText: "Stages",
      //   path: "/dashboard/matter-stages",
      //   accessId: "sidebar_matter_stages",
      // },
      {
        mIcon: <ViewQuiltRoundedIcon sx={{ fontSize: "1rem" }} />,
        mText: "Templates",
        path: "/dashboard/matter-template",
        accessId: "sidebar_matter_templates",
      },
    ],
  },
  {
    mIcon: <PeopleOutlineRoundedIcon sx={{ fontSize: "1rem" }} />,
    mText: "People",
    path: "/dashboard/people",
    accessId: "sidebar_people",
  },
  {
    mIcon: <BusinessRoundedIcon sx={{ fontSize: "1rem" }} />,
    mText: "Companies",
    path: "/dashboard/companies",
    accessId: "sidebar_companies",
  },
  {
    mIcon: <TuneRoundedIcon sx={{ fontSize: "1rem" }} />,
    mText: "Activities",
    path: "/dashboard/activities",
    accessId: "sidebar_activities",
  },
  {
    mIcon: <RequestQuoteRoundedIcon sx={{ fontSize: "1rem" }} />,
    mText: "Billing",
    path: "/dashboard/bills",
    accessId: "sidebar_billing",
  },
  {
    mIcon: <AccountBalanceRoundedIcon sx={{ fontSize: "1rem" }} />,
    mText: "Bankers",
    path: "/dashboard/bank_accounts",
    accessId: "sidebar_accounts",
  },
  {
    mIcon: <FolderRoundedIcon sx={{ fontSize: "1rem" }} />,
    mText: "Documents",
    path: "/dashboard/documents",
    accessId: "sidebar_documents",
    subMenu: [
      {
        mIcon: <FolderRoundedIcon sx={{ fontSize: "1rem" }} />,
        mText: "Documents",
        path: "/dashboard/documents",
        accessId: "sidebar_documents_main",
      },
      {
        mIcon: <RuleFolderRoundedIcon sx={{ fontSize: "1rem" }} />,
        mText: "Templates",
        path: "/dashboard/documents/templates",
        accessId: "sidebar_document_templates",
      },
      // {
      //   mIcon: <HistoryEduRoundedIcon sx={{ fontSize: "1rem" }} />,
      //   mText: "Categories",
      //   path: "/dashboard/documents/categories",
      //   accessId: "sidebar_document_categories",
      // },
    ],
  },
  {
    mIcon: <QuestionAnswerRoundedIcon sx={{ fontSize: "1rem" }} />,
    mText: "Communication",
    path: "/dashboard/communications",
    accessId: "sidebar_communications",
  },
  // {
  //   mIcon: <AccessTimeRoundedIcon sx={{ fontSize: "1rem" }} />,
  //   mText: "Reports",
  //   path: "/dashboard/reports",
  //   accessId: "sidebar_reports",
  // },
  // {
  //   mIcon: <AppSettingsAltRoundedIcon sx={{ fontSize: "1rem" }} />,
  //   mText: "App Integrations",
  //   // path: "/dashboard/app_integrations",
  //   accessId: "sidebar_app_integrations",
  // },
  // {
  //   mIcon: <DescriptionRoundedIcon sx={{ fontSize: "1rem" }} />,
  //   mText: "Custom Fields",
  //   path: "/dashboard/custom_fields", this we use in setting page inside Form Layout & Custom Fields and only for the contact form
  //   accessId: "sidebar_custom_fields",
  // },
  {
    mIcon: <SettingsRoundedIcon sx={{ fontSize: "1rem" }} />,
    mText: "Settings",
    path: "/dashboard/settings",
    accessId: "sidebar_settings",
  },
];

export const genders = ["male", "female", "others"];

export const createNewOpenFormName = [
  { label: "Add Team Member", value: "add_team_member" },
  // { label: "Add Agenda", value: "add_agenda" },
  { label: "Add Task", value: "add_task" },
  { label: "Add Task Template", value: "add_task_template" },
  { label: "Add Group Tasks", value: "add_group_tasks" },
  { label: "Add Matter", value: "add_matter" },
  { label: "Add Matter Template", value: "add_matter_template" },
  { label: "Add Person", value: "add_person" },
  { label: "Add Company", value: "add_company" },
  // { label: "New Bill", value: "new_bill" },
  { label: "Record Payment", value: "record_payment" },
  { label: "New Trust request", value: "new_trust_request" },
  { label: "New Account", value: "new_account" },
  { label: "New Transaction", value: "new_transaction" },
  { label: "Transfer funds", value: "transfer_funds" },
];

// this for tag loading pattern in contact tags
export const CHIP_PATTERNS = [
  [89, 70, 60, 80], // Row 1
  [90, 60, 50], // Row 2
  [40, 50, 70, 60, 80], // Row 3
  [60, 50, 90], // Row 4
];

export function isFirstTimeVisit(uniqueKey) {
  if (!uniqueKey) {
    console.warn("⚠️ isFirstTimeVisit: uniqueKey is required");
    return false;
  }

  const key = `visited_${uniqueKey}`;
  const hasVisited = localStorage.getItem(key);

  if (!hasVisited) {
    localStorage.setItem(key, "true");
    return true; // 🆕 first-time visitor
  }

  return false; // 👋 returning visitor
}

export const handleMatterNewTab = () => {
  const baseUrl = window.location.origin;

  const newUrl = `${baseUrl}/dashboard/matter`;

  const newTab = window.open(newUrl, "_blank");

  if (newTab) {
    newTab.onload = () => {
      newTab.sessionStorage.setItem("dialogCase", "true");
    };
  }
};

export const NoDataOptionField = ({
  imgSrc,
  text,
  btnText,
  handleClickNoData,
  endIcon,
}) => {
  return (
    <>
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: "0.5rem",
        }}
      >
        <Box sx={{ height: "7rem" }}>
          <img
            src={imgSrc}
            alt="No Data"
            style={{
              height: "100%",
              width: "100%",
              objectFit: "contain",
            }}
            onError={(e) => {
              e.onerror = null;
              e.target.src = require("../assets/no-option-found.webp");
            }}
          />
        </Box>
        <Typography
          variant="body1"
          sx={{
            fontSize: "0.9rem",
            textAlign: "center",
          }}
        >
          {text}
        </Typography>
        {btnText && handleClickNoData ? (
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleClickNoData}
            endIcon={endIcon}
          >
            Create {btnText}
          </Button>
        ) : null}
      </Box>
    </>
  );
};

export const ListboxComponent = ({
  btnIcon,
  btnText,
  handleClikListBtn,
  children,
  ...other
}) => (
  <Box sx={{ position: "relative" }}>
    <ul
      {...other}
      style={{
        maxHeight: "12.5rem",
        overflowY: "auto",
        margin: 0,
        padding: 0,
      }}
    >
      {children}
    </ul>
    <Box
      sx={{
        position: "sticky",
        bottom: 0,
        borderTop: "1px solid #e5e5e5",
        backgroundColor: "white",
        padding: "8px",
        display: "flex",
        justifyContent: "flex-end",
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <Button
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleClikListBtn();
        }}
        onMouseDown={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        variant="text"
        size="small"
        color="primary"
        endIcon={btnIcon}
      >
        {btnText}
      </Button>
    </Box>
  </Box>
);

export const DataGridNoData = ({ imgSrc, text }) => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      p: "2rem",
      gap: "1rem",
    }}
  >
    <Box sx={{ height: "10rem" }}>
      <img
        src={imgSrc}
        alt="Company Logo"
        style={{
          height: "100%",
          width: "100%",
          objectFit: "cover",
        }}
        onError={(e) => {
          e.onerror = null;
          e.target.src = require("../assets/no-preview.webp");
        }}
      />
    </Box>
    <Typography variant="body1">{text}</Typography>
  </Box>
);

export const renderContactOption = (props, option) => (
  <li
    {...props}
    style={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <Typography variant="body1">
      {option?.first_name
        ? `${option?.first_name} ${option?.last_name}`
        : option?.company_name
        ? option?.company_name
        : ""}
    </Typography>
    <Typography variant="body1">
      {option?.contact_type === "person" ? (
        <AccountCircleRoundedIcon
          sx={{ color: "#bf3fe1", fontSize: "0.9rem" }}
        />
      ) : (
        <BusinessRoundedIcon sx={{ color: "#2e77f5", fontSize: "0.9rem" }} />
      )}
    </Typography>
  </li>
);

export const allCustomFieldsTypes = [
  {
    icons: <ShortTextIcon sx={{ fontSize: "1rem" }} />,
    name: "Single Line",
    value: "single_line",
    defaultLabel: "Single Line",
    field_type: "text",
  },
  {
    icons: <TextFieldsIcon sx={{ fontSize: "1rem" }} />,
    name: "Multiple Line",
    value: "multi_line",
    defaultLabel: "Multiple Line",
    field_type: "text",
  },
  {
    icons: <EmailIcon sx={{ fontSize: "1rem" }} />,
    name: "Email",
    value: "email",
    defaultLabel: "Email",
    field_type: "email",
  },
  {
    icons: <PhoneIcon sx={{ fontSize: "1rem" }} />,
    name: "Phone",
    value: "phone",
    defaultLabel: "Phone Number",
    field_type: "number",
  },
  {
    icons: <ArrowDropDownCircleIcon sx={{ fontSize: "1rem" }} />,
    name: "Pick List",
    value: "pick_list",
    defaultLabel: "Pick List",
    field_type: "select",
  },
  // {
  //   icons: <ViewListIcon sx={{ fontSize: "1rem" }} />,
  //   name: "Multiple Select",
  //   value: "multi_select",
  //   defaultLabel: "Multiple Select",
  //   field_type: "select",
  // },
  {
    icons: <CalendarTodayIcon sx={{ fontSize: "1rem" }} />,
    name: "Date",
    value: "date",
    defaultLabel: "Date",
    field_type: "date",
  },
  {
    icons: <AccessTimeIcon sx={{ fontSize: "1rem" }} />,
    name: "Date & Time",
    value: "date_time",
    defaultLabel: "Date & Time",
    field_type: "datetime-local",
  },
  {
    icons: <Filter1Icon sx={{ fontSize: "1rem" }} />,
    name: "Number",
    value: "number",
    defaultLabel: "Number",
    field_type: "number",
  },
  // {
  //   icons: <TagIcon sx={{ fontSize: "1rem" }} />,
  //   name: "Auto-Number",
  //   value: "auto_number",
  //   defaultLabel: "Auto-Number",
  //   field_type: "number"
  // },
  {
    icons: <AttachMoneyIcon sx={{ fontSize: "1rem" }} />,
    name: "Currency",
    value: "currency",
    defaultLabel: "Currency",
    field_type: "number",
  },
  {
    icons: <PinIcon sx={{ fontSize: "1rem" }} />,
    name: "Decimal",
    value: "decimal",
    defaultLabel: "Decimal",
    field_type: "number",
  },
  {
    icons: <PercentIcon sx={{ fontSize: "1rem" }} />,
    name: "Percent",
    value: "percent",
    defaultLabel: "Percent",
    field_type: "number",
  },
  {
    icons: <Filter9PlusIcon sx={{ fontSize: "1rem" }} />,
    name: "Long Integer",
    value: "long_integer",
    defaultLabel: "Long Integer",
    field_type: "number",
  },
  {
    icons: <CheckBoxIcon sx={{ fontSize: "1rem" }} />,
    name: "Checkbox",
    value: "check_box",
    defaultLabel: "Checkbox",
    field_type: "boolean",
  },
  // {
  //   icons: <ViewHeadlineIcon sx={{ fontSize: "1rem" }} />,
  //   name: "Lookup",
  //   value: "lookup",
  //   defaultLabel: "Lookup",

  // },
  // {
  //   icons: <FunctionsIcon sx={{ fontSize: "1rem" }} />,
  //   name: "Formula",
  //   value: "formula",
  //   defaultLabel: "Formula",
  // },
  // {
  //   icons: <PersonIcon sx={{ fontSize: "1rem" }} />,
  //   name: "User",
  //   value: "user",
  //   defaultLabel: "User",
  // },
  // {
  //   icons: <AttachFileIcon sx={{ fontSize: "1rem" }} />,
  //   name: "File Upload",
  //   value: "file_upload",
  //   defaultLabel: "File Upload",
  // },
  // {
  //   icons: <ImageIcon sx={{ fontSize: "1rem" }} />,
  //   name: "Image Upload",
  //   value: "img_upload",
  //   defaultLabel: "Image Upload",
  // },
];
export const fieldTypeLabelMap = allCustomFieldsTypes.reduce((acc, item) => {
  acc[item.value] = item.name;
  return acc;
}, {});

export const countryOptions = [
  { code: "+1", label: "United States / Canada" },
  { code: "+7", label: "Russia / Kazakhstan" },
  { code: "+20", label: "Egypt" },
  { code: "+27", label: "South Africa" },
  { code: "+30", label: "Greece" },
  { code: "+31", label: "Netherlands" },
  { code: "+32", label: "Belgium" },
  { code: "+33", label: "France" },
  { code: "+34", label: "Spain" },
  { code: "+36", label: "Hungary" },
  { code: "+39", label: "Italy" },
  { code: "+40", label: "Romania" },
  { code: "+41", label: "Switzerland" },
  { code: "+43", label: "Austria" },
  { code: "+44", label: "United Kingdom" },
  { code: "+45", label: "Denmark" },
  { code: "+46", label: "Sweden" },
  { code: "+47", label: "Norway" },
  { code: "+48", label: "Poland" },
  { code: "+49", label: "Germany" },
  { code: "+51", label: "Peru" },
  { code: "+52", label: "Mexico" },
  { code: "+53", label: "Cuba" },
  { code: "+54", label: "Argentina" },
  { code: "+55", label: "Brazil" },
  { code: "+56", label: "Chile" },
  { code: "+57", label: "Colombia" },
  { code: "+58", label: "Venezuela" },
  { code: "+60", label: "Malaysia" },
  { code: "+61", label: "Australia" },
  { code: "+62", label: "Indonesia" },
  { code: "+63", label: "Philippines" },
  { code: "+64", label: "New Zealand" },
  { code: "+65", label: "Singapore" },
  { code: "+66", label: "Thailand" },
  { code: "+81", label: "Japan" },
  { code: "+82", label: "South Korea" },
  { code: "+84", label: "Vietnam" },
  { code: "+86", label: "China" },
  { code: "+90", label: "Turkey" },
  { code: "+91", label: "India" },
  { code: "+92", label: "Pakistan" },
  { code: "+93", label: "Afghanistan" },
  { code: "+94", label: "Sri Lanka" },
  { code: "+95", label: "Myanmar" },
  { code: "+98", label: "Iran" },
  { code: "+211", label: "South Sudan" },
  { code: "+212", label: "Morocco" },
  { code: "+213", label: "Algeria" },
  { code: "+216", label: "Tunisia" },
  { code: "+218", label: "Libya" },
  { code: "+220", label: "Gambia" },
  { code: "+221", label: "Senegal" },
  { code: "+222", label: "Mauritania" },
  { code: "+223", label: "Mali" },
  { code: "+224", label: "Guinea" },
  { code: "+225", label: "Ivory Coast" },
  { code: "+226", label: "Burkina Faso" },
  { code: "+227", label: "Niger" },
  { code: "+228", label: "Togo" },
  { code: "+229", label: "Benin" },
  { code: "+230", label: "Mauritius" },
  { code: "+231", label: "Liberia" },
  { code: "+232", label: "Sierra Leone" },
  { code: "+233", label: "Ghana" },
  { code: "+234", label: "Nigeria" },
  { code: "+235", label: "Chad" },
  { code: "+236", label: "Central African Republic" },
  { code: "+237", label: "Cameroon" },
  { code: "+238", label: "Cape Verde" },
  { code: "+239", label: "Sao Tome and Principe" },
  { code: "+240", label: "Equatorial Guinea" },
  { code: "+241", label: "Gabon" },
  { code: "+242", label: "Congo" },
  { code: "+243", label: "Democratic Republic of Congo" },
  { code: "+244", label: "Angola" },
  { code: "+245", label: "Guinea-Bissau" },
  { code: "+246", label: "British Indian Ocean Territory" },
  { code: "+248", label: "Seychelles" },
  { code: "+249", label: "Sudan" },
  { code: "+250", label: "Rwanda" },
  { code: "+251", label: "Ethiopia" },
  { code: "+252", label: "Somalia" },
  { code: "+253", label: "Djibouti" },
  { code: "+254", label: "Kenya" },
  { code: "+255", label: "Tanzania" },
  { code: "+256", label: "Uganda" },
  { code: "+257", label: "Burundi" },
  { code: "+258", label: "Mozambique" },
  { code: "+260", label: "Zambia" },
  { code: "+261", label: "Madagascar" },
  { code: "+262", label: "Reunion / Mayotte" },
  { code: "+263", label: "Zimbabwe" },
  { code: "+264", label: "Namibia" },
  { code: "+265", label: "Malawi" },
  { code: "+266", label: "Lesotho" },
  { code: "+267", label: "Botswana" },
  { code: "+268", label: "Eswatini" },
  { code: "+269", label: "Comoros" },
  { code: "+290", label: "Saint Helena" },
  { code: "+291", label: "Eritrea" },
  { code: "+297", label: "Aruba" },
  { code: "+298", label: "Faroe Islands" },
  { code: "+299", label: "Greenland" },
  { code: "+350", label: "Gibraltar" },
  { code: "+351", label: "Portugal" },
  { code: "+352", label: "Luxembourg" },
  { code: "+353", label: "Ireland" },
  { code: "+354", label: "Iceland" },
  { code: "+355", label: "Albania" },
  { code: "+356", label: "Malta" },
  { code: "+357", label: "Cyprus" },
  { code: "+358", label: "Finland" },
  { code: "+359", label: "Bulgaria" },
  { code: "+370", label: "Lithuania" },
  { code: "+371", label: "Latvia" },
  { code: "+372", label: "Estonia" },
  { code: "+373", label: "Moldova" },
  { code: "+374", label: "Armenia" },
  { code: "+375", label: "Belarus" },
  { code: "+376", label: "Andorra" },
  { code: "+377", label: "Monaco" },
  { code: "+378", label: "San Marino" },
  { code: "+380", label: "Ukraine" },
  { code: "+381", label: "Serbia" },
  { code: "+382", label: "Montenegro" },
  { code: "+383", label: "Kosovo" },
  { code: "+385", label: "Croatia" },
  { code: "+386", label: "Slovenia" },
  { code: "+387", label: "Bosnia and Herzegovina" },
  { code: "+389", label: "North Macedonia" },
  { code: "+420", label: "Czech Republic" },
  { code: "+421", label: "Slovakia" },
  { code: "+423", label: "Liechtenstein" },
  { code: "+500", label: "Falkland Islands" },
  { code: "+501", label: "Belize" },
  { code: "+502", label: "Guatemala" },
  { code: "+503", label: "El Salvador" },
  { code: "+504", label: "Honduras" },
  { code: "+505", label: "Nicaragua" },
  { code: "+506", label: "Costa Rica" },
  { code: "+507", label: "Panama" },
  { code: "+508", label: "Saint Pierre and Miquelon" },
  { code: "+509", label: "Haiti" },
  { code: "+590", label: "Guadeloupe / Saint Martin" },
  { code: "+591", label: "Bolivia" },
  { code: "+592", label: "Guyana" },
  { code: "+593", label: "Ecuador" },
  { code: "+594", label: "French Guiana" },
  { code: "+595", label: "Paraguay" },
  { code: "+596", label: "Martinique" },
  { code: "+597", label: "Suriname" },
  { code: "+598", label: "Uruguay" },
  { code: "+599", label: "Caribbean Netherlands / Curacao" },
  { code: "+670", label: "Timor-Leste" },
  { code: "+672", label: "Australian External Territories" },
  { code: "+673", label: "Brunei" },
  { code: "+674", label: "Nauru" },
  { code: "+675", label: "Papua New Guinea" },
  { code: "+676", label: "Tonga" },
  { code: "+677", label: "Solomon Islands" },
  { code: "+678", label: "Vanuatu" },
  { code: "+679", label: "Fiji" },
  { code: "+680", label: "Palau" },
  { code: "+681", label: "Wallis and Futuna" },
  { code: "+682", label: "Cook Islands" },
  { code: "+683", label: "Niue" },
  { code: "+685", label: "Samoa" },
  { code: "+686", label: "Kiribati" },
  { code: "+687", label: "New Caledonia" },
  { code: "+688", label: "Tuvalu" },
  { code: "+689", label: "French Polynesia" },
  { code: "+690", label: "Tokelau" },
  { code: "+691", label: "Micronesia" },
  { code: "+692", label: "Marshall Islands" },
  { code: "+850", label: "North Korea" },
  { code: "+852", label: "Hong Kong" },
  { code: "+853", label: "Macau" },
  { code: "+855", label: "Cambodia" },
  { code: "+856", label: "Laos" },
  { code: "+870", label: "Inmarsat" },
  { code: "+880", label: "Bangladesh" },
  { code: "+886", label: "Taiwan" },
  { code: "+960", label: "Maldives" },
  { code: "+961", label: "Lebanon" },
  { code: "+962", label: "Jordan" },
  { code: "+963", label: "Syria" },
  { code: "+964", label: "Iraq" },
  { code: "+965", label: "Kuwait" },
  { code: "+966", label: "Saudi Arabia" },
  { code: "+967", label: "Yemen" },
  { code: "+968", label: "Oman" },
  { code: "+970", label: "Palestine" },
  { code: "+971", label: "United Arab Emirates" },
  { code: "+972", label: "Israel" },
  { code: "+973", label: "Bahrain" },
  { code: "+974", label: "Qatar" },
  { code: "+975", label: "Bhutan" },
  { code: "+976", label: "Mongolia" },
  { code: "+977", label: "Nepal" },
  { code: "+992", label: "Tajikistan" },
  { code: "+993", label: "Turkmenistan" },
  { code: "+994", label: "Azerbaijan" },
  { code: "+995", label: "Georgia" },
  { code: "+996", label: "Kyrgyzstan" },
  { code: "+998", label: "Uzbekistan" },
];

// Legacy currency seed data kept here temporarily for settings migration support.
export const legacyCurrencySeed = [
  { label: "🇺🇸 USD - United States Dollar ($)", value: "USD", symbol: "$" },
  { label: "🇪🇺 EUR - Euro (€)", value: "EUR", symbol: "€" },
  { label: "🇬🇧 GBP - British Pound (£)", value: "GBP", symbol: "£" },
  { label: "🇯🇵 JPY - Japanese Yen (¥)", value: "JPY", symbol: "¥" },
  { label: "🇦🇺 AUD - Australian Dollar (A$)", value: "AUD", symbol: "A$" },
  { label: "🇨🇦 CAD - Canadian Dollar (C$)", value: "CAD", symbol: "C$" },
  { label: "🇨🇭 CHF - Swiss Franc (CHF)", value: "CHF", symbol: "CHF" },
  { label: "🇨🇳 CNY - Chinese Yuan (¥)", value: "CNY", symbol: "¥" },
  { label: "🇮🇳 INR - Indian Rupee (₹)", value: "INR", symbol: "₹" },
  { label: "🇧🇷 BRL - Brazilian Real (R$)", value: "BRL", symbol: "R$" },
  { label: "🇿🇦 ZAR - South African Rand (R)", value: "ZAR", symbol: "R" },
  { label: "🇳🇿 NZD - New Zealand Dollar (NZ$)", value: "NZD", symbol: "NZ$" },
  { label: "🇲🇽 MXN - Mexican Peso (MX$)", value: "MXN", symbol: "MX$" },
];

export const paymentMethods = [
  { label: "Direct - Check", value: "check" },
  { label: "Direct - Cash", value: "cash" },
  { label: "Direct - Credit Card", value: "credit_card" },
  { label: "Direct - Debit Card", value: "debit_card" },
  { label: "Direct - eCheck (ACH) Payments", value: "ach" },
  { label: "Direct - Apple Pay", value: "apple_pay" },
  { label: "Direct - Google Pay", value: "google_pay" },
  { label: "Direct - Bank Transfer (Wire Transfer)", value: "bank_transfer" },
  { label: "Other - Money Order", value: "money_order" },
  { label: "Other - Bank Draft", value: "bank_draft" },
  { label: "Other - Third-Party Payment", value: "third_party" },
  { label: "Other", value: "other" },
];

// export const Access_modules = [
//   {
//     id: "feature_dashboard",
//     path: "/dashboard",
//     mText: "Dashboard",
//     subMenu: [
//       {
//         id: "feature_firm_dashboard",
//         mText: "Firm Dashboard",
//         description: "Access to firm-wide analytics and metrics",
//         permissions: [
//           {
//             id: "access_firm_dashboard_revenue_chart",
//             key: "revenue_chart",
//             label: "Revenue Trend Chart",
//             description: "View revenue vs target trends",
//           },
//           {
//             id: "access_firm_dashboard_matter_status_chart",
//             key: "matter_status_chart",
//             label: "Matter Status Chart",
//             description: "View distribution of matter status",
//           },
//           {
//             id: "access_firm_dashboard_practice_area_chart",
//             key: "practice_area_chart",
//             label: "Practice Areas Chart",
//             description: "View revenue by practice area",
//           },
//           {
//             id: "access_firm_dashboard_top_users_chart",
//             key: "top_users_chart",
//             label: "Top Users Chart",
//             description: "View earnings leaderboard",
//           },
//           {
//             id: "access_firm_dashboard_recent_activity",
//             key: "recent_activity",
//             label: "Recent Activity Feed",
//             description: "View recent activities",
//           },
//           {
//             id: "access_firm_dashboard_graph3",
//             key: "additional_graph",
//             label: "Additional Graph",
//             description: "View additional analytics graph",
//           },
//         ],
//       },
//     ],
//     sidebarId: "sidebar_dashboard",
//     description: "Main dashboard and overview pages",
//     featureName: "Personal & Firm Dashboard",
//     excludePaths: [],
//     planInModule: "",
//     can_t_disable: true,
//   },
//   {
//     id: "feature_calendar",
//     path: "/dashboard/calendars",
//     mText: "Calendar",
//     sidebarId: "sidebar_calendar",
//     description: "Calendar and event management system",
//     featureName: "Calendar Views",
//   },
//   {
//     id: "feature_tasks_flow",
//     mText: "Tasks flow",
//     subMenu: [
//       {
//         id: "feature_tasks",
//         path: "/dashboard/tasks",
//         mText: "Tasks",
//         sidebarId: "sidebar_tasks",
//         description: "View and manage all tasks",
//         permissions: [
//           {
//             id: "access_new_task_btn",
//             key: "create",
//             label: "Create",
//             description: "Create new tasks",
//           },
//           {
//             id: "access_new_task_edit_btn",
//             key: "edit",
//             label: "Edit",
//             description: "Edit existing tasks",
//           },
//           {
//             id: "access_new_task_del_btn",
//             key: "delete",
//             label: "Delete",
//             description: "Delete tasks",
//           },
//           {
//             id: "access_assign_to_other",
//             key: "assign",
//             label: "Assign to Others",
//             description: "Assign tasks to other team members",
//           },
//           {
//             id: "access_private_task_input",
//             key: "private",
//             label: "Can create private task",
//             description: "Private tasks visible only to creator",
//           },
//           {
//             id: "access_view_all_tasks",
//             key: "view_all_tasks",
//             label: "View All Tasks",
//             description: "View tasks not assigned to the user",
//           },
//         ],
//         excludePaths: ["/dashboard/tasks/archived"],
//       },
//       {
//         id: "feature_task_template",
//         path: "/dashboard/task/template",
//         mText: "Task Template",
//         sidebarId: "sidebar_task_template",
//         description: "Manage reusable task templates",
//         permissions: [
//           {
//             id: "access_task_template_create",
//             key: "create",
//             label: "Create Template",
//             description: "Create new reusable task templates",
//           },
//           {
//             id: "access_task_template_edit",
//             key: "edit",
//             label: "Edit Template",
//             description: "Edit existing task templates",
//           },
//           {
//             id: "access_task_template_delete",
//             key: "delete",
//             label: "Delete Template",
//             description: "Delete task templates",
//           },
//           // {
//           //   id: "access_task_template_duplicate",
//           //   key: "duplicate",
//           //   label: "Duplicate Template",
//           //   description: "Duplicate existing templates for reuse",
//           // },
//           // {
//           //   id: "access_task_template_assign",
//           //   key: "assign",
//           //   label: "Assign Template",
//           //   description: "Assign task templates to users or matters",
//           // },
//           // {
//           //   id: "access_task_template_share",
//           //   key: "share",
//           //   label: "Share Template",
//           //   description: "Share templates with other team members",
//           // },
//         ],
//       },
//       {
//         id: "feature_group_tasks",
//         path: "/dashboard/task/group-tasks",
//         mText: "Group Tasks",
//         sidebarId: "sidebar_task_group_tasks",
//         description: "Grouped task workflows",
//         permissions: [
//           {
//             id: "access_group_tasks_create",
//             key: "create",
//             label: "Create Group Task",
//             description: "Create a new group task or workflow",
//           },
//           {
//             id: "access_group_tasks_edit",
//             key: "edit",
//             label: "Edit Group Task",
//             description: "Edit details or tasks within a group",
//           },
//           {
//             id: "access_group_tasks_delete",
//             key: "delete",
//             label: "Delete Group Task",
//             description: "Delete group tasks or workflows",
//           },
//           // {
//           //   id: "access_group_tasks_add_subtask",
//           //   key: "add_subtask",
//           //   label: "Add Subtask",
//           //   description: "Add new subtasks to an existing group",
//           // },
//           // {
//           //   id: "access_group_tasks_assign",
//           //   key: "assign",
//           //   label: "Assign Group Task",
//           //   description: "Assign group tasks to users or teams",
//           // },
//           // {
//           //   id: "access_group_tasks_complete",
//           //   key: "mark_complete",
//           //   label: "Mark Complete",
//           //   description: "Mark group tasks or subtasks as completed",
//           // },
//           // {
//           //   id: "access_group_tasks_reorder",
//           //   key: "reorder",
//           //   label: "Reorder Tasks",
//           //   description: "Change task order within a group",
//           // },
//           // {
//           //   id: "access_group_tasks_view_progress",
//           //   key: "view_progress",
//           //   label: "View Progress",
//           //   description:
//           //     "View progress or completion percentage of grouped tasks",
//           // },
//         ],
//       },
//     ],
//     sidebarId: "sidebar_tasks_flow",
//     description: "Task management and templates",
//     featureName: "Task Flow Management",
//   },
//   {
//     id: "feature_matters",
//     mText: "Matters",
//     subMenu: [
//       {
//         id: "feature_all_matters",
//         path: "/dashboard/matter",
//         mText: "All Matters",
//         sidebarId: "sidebar_all_matters",
//         description: "View and manage all legal matters",
//         permissions: [
//           {
//             id: "access_matters_create",
//             key: "create",
//             label: "Create",
//             description: "Create new legal matters",
//           },
//           {
//             id: "access_matters_edit",
//             key: "edit",
//             label: "Edit",
//             description: "Edit existing matters",
//           },
//           {
//             id: "access_matters_delete",
//             key: "delete",
//             label: "Delete",
//             description: "Delete matters",
//           },
//           {
//             id: "access_matters_close",
//             key: "close",
//             label: "Close Matters",
//             description: "Mark matters as closed",
//           },
//           {
//             id: "access_case_dashboard",
//             key: "matter_dashboard",
//             label: "Matter Dashboard",
//             description: "View individual matter dashboard",
//           },
//           {
//             key: "matter_restricted_access",
//             type: "switch",
//             label: "Only See Assigned Matters",
//             description: "Restricts matter visibility to only assigned matters",
//           },
//         ],
//       },
//       {
//         id: "feature_matter_templates",
//         path: "/dashboard/matter-template",
//         mText: "Templates",
//         sidebarId: "sidebar_matter_templates",
//         description: "Manage matter templates",
//         permissions: [
//           {
//             id: "access_matter_templates_create",
//             key: "create",
//             label: "Create Templates",
//             description: "Create new matter templates",
//           },
//           {
//             id: "access_matter_templates_edit",
//             key: "edit",
//             label: "Edit Templates",
//             description: "Edit existing templates",
//           },
//           {
//             id: "access_matter_templates_delete",
//             key: "delete",
//             label: "Delete Templates",
//             description: "Delete matter templates",
//           },
//         ],
//       },
//     ],
//     sidebarId: "sidebar_matters",
//     description: "Legal matter and case management",
//     featureName: "Matter Management",
//   },
//   {
//     id: "feature_people",
//     path: "/dashboard/people",
//     mText: "People",
//     sidebarId: "sidebar_people",
//     description: "Create people for solo matters or include them in companies",
//     featureName: "People Contacts",
//     permissions: [
//       {
//         id: "access_people_create",
//         key: "create",
//         label: "Create",
//         description: "Add new people",
//       },
//       {
//         id: "access_people_edit",
//         key: "edit",
//         label: "Edit",
//         description: "Edit existing people",
//       },
//       {
//         id: "access_people_delete",
//         key: "delete",
//         label: "Delete",
//         description: "Delete people",
//       },
//       {
//         id: "access_people_export",
//         key: "export",
//         label: "Export",
//         description: "Export people data",
//       },
//       {
//         id: "access_people_import",
//         key: "import",
//         label: "Import",
//         description: "Import people data",
//       },
//       {
//         id: "access_people_tags",
//         key: "tags",
//         label: "Manage Tags",
//         description: "Manage people tags",
//       },
//     ],
//     excludePaths: [
//       "/dashboard/people/trash",
//       "/dashboard/people/export-history",
//     ],
//   },
//   {
//     id: "feature_companies",
//     path: "/dashboard/companies",
//     mText: "Companies",
//     sidebarId: "sidebar_companies",
//     description: "Companies management",
//     featureName: "Companies Contacts",
//     permissions: [
//       {
//         id: "access_companies_create",
//         key: "create",
//         label: "Create",
//         description: "Add new companies",
//       },
//       {
//         id: "access_companies_edit",
//         key: "edit",
//         label: "Edit",
//         description: "Edit existing companies",
//       },
//       {
//         id: "access_companies_delete",
//         key: "delete",
//         label: "Delete",
//         description: "Delete companies",
//       },
//       {
//         id: "access_companies_export",
//         key: "export",
//         label: "Export",
//         description: "Export company data",
//       },
//       {
//         id: "access_companies_import",
//         key: "import",
//         label: "Import",
//         description: "Import company data",
//       },
//       {
//         id: "access_companies_tags",
//         key: "tags",
//         label: "Manage Tags",
//         description: "Manage company tags",
//       },
//     ],
//     excludePaths: [
//       "/dashboard/companies/trash",
//       "/dashboard/companies/export-history",
//     ],
//   },
//   {
//     id: "feature_activities",
//     path: "/dashboard/activities",
//     mText: "Activities",
//     sidebarId: "sidebar_activities",
//     description: "Activity tracking and time logging",
//     featureName: "Activity Tracking",
//     permissions: [
//       {
//         id: "access_activities_create",
//         key: "create",
//         label: "Create",
//         description: "Create new activities",
//       },
//       {
//         id: "access_activities_edit",
//         key: "edit",
//         label: "Edit",
//         description: "Edit existing activities",
//       },
//       {
//         id: "access_activities_delete",
//         key: "delete",
//         label: "Delete",
//         description: "Delete activities",
//       },
//       {
//         id: "access_activities_log_time",
//         key: "log_time",
//         label: "Log Time",
//         description: "Log time entries for activities",
//       },
//       {
//         id: "access_activities_add_exp",
//         key: "add_exp",
//         label: "Log Expense",
//         description: "Add expense entries",
//       },
//       {
//         id: "access_activities_add_exp_categories",
//         key: "add_exp_categories",
//         label: "Can add categories",
//         description: "Create new expense categories",
//       },
//     ],
//   },
//   {
//     id: "feature_billing",
//     path: "/dashboard/bills",
//     mText: "Billing",
//     sidebarId: "sidebar_billing",
//     description: "Billing and invoice management",
//     featureName: "Billing & Invoicing",
//     permissions: [
//       {
//         id: "access_billing_create",
//         key: "create",
//         label: "Create Bills",
//         description: "Create new bills and invoices",
//       },
//       {
//         id: "access_billing_edit",
//         key: "edit",
//         label: "Edit Bills",
//         description: "Edit existing bills",
//       },
//       {
//         id: "access_billing_delete",
//         key: "delete",
//         label: "Delete Bills",
//         description: "Delete bills and invoices",
//       },
//       {
//         id: "access_billing_send",
//         key: "send",
//         label: "Send Bills",
//         description: "Send bills to clients",
//       },
//       {
//         id: "access_billing_download",
//         key: "download",
//         label: "Download Bills",
//         description: "Download bill documents",
//       },
//       {
//         id: "access_billing_approve",
//         key: "approve",
//         label: "Approve Bills",
//         description: "Approve bills before sending",
//       },
//       {
//         id: "access_billing_payment",
//         key: "payment",
//         label: "Record Payments",
//         description: "Record bill payments",
//       },
//     ],
//   },
//   {
//     id: "feature_bankers",
//     path: "/dashboard/bank_accounts",
//     mText: "Bankers",
//     subMenu: [
//       {
//         id: "feature_all_accounts",
//         path: "/dashboard/bank_accounts",
//         mText: "All Accounts",
//         sidebarId: "sidebar_all_accounts",
//         description: "View and manage all financial accounts",
//         permissions: [
//           {
//             id: "access_accounts_create",
//             key: "create",
//             label: "Create Accounts",
//             description: "Create new financial accounts",
//           },
//           {
//             id: "access_accounts_edit",
//             key: "edit",
//             label: "Edit Accounts",
//             description: "Edit existing accounts",
//           },
//           {
//             id: "access_accounts_delete",
//             key: "delete",
//             label: "Delete Accounts",
//             description: "Delete financial accounts",
//           },
//           {
//             id: "access_accounts_view_client",
//             key: "view_client_account",
//             label: "Client's Accounts",
//             description: "View client financial accounts",
//           },
//           {
//             id: "access_accounts_view_firm",
//             key: "view_firm_account",
//             label: "Firm's Accounts",
//             description: "View firm's financial accounts",
//           },
//         ],
//       },
//       {
//         id: "feature_transactions",
//         path: "/dashboard/bank_accounts/:id/:accountName",
//         mText: "Transactions",
//         sidebarId: "sidebar_transactions",
//         description: "Manage account transactions",
//         permissions: [
//           {
//             id: "access_transactions_edit",
//             key: "edit",
//             label: "Edit Statements",
//             description: "Edit transaction statements",
//           },
//           {
//             id: "access_transactions_delete",
//             key: "delete",
//             label: "Delete Statements",
//             description: "Delete transaction statements",
//           },
//           {
//             id: "access_transactions_transfer",
//             key: "tranfer_funds",
//             label: "Transfer Funds",
//             description: "Transfer funds between accounts",
//           },
//           {
//             id: "access_transactions_new",
//             key: "new_transactions",
//             label: "New Transactions",
//             description: "Create new transactions",
//           },
//           {
//             id: "access_transactions_export",
//             key: "export_statement",
//             label: "Export Statements",
//             description: "Export transaction statements",
//           },
//         ],
//       },
//     ],
//     sidebarId: "sidebar_accounts",
//     description: "Financial account management",
//     featureName: "Virtual Bank Management",
//   },
//   {
//     id: "feature_documents",
//     path: "/dashboard/documents",
//     mText: "Documents",
//     subMenu: [
//       {
//         id: "feature_documents_main",
//         path: "/dashboard/documents",
//         mText: "Documents",
//         sidebarId: "sidebar_documents_main",
//         description: "Browse, search, and manage the document library",
//         permissions: [
//           {
//             id: "access_documents_upload",
//             key: "upload",
//             label: "Upload",
//             description: "Upload new documents",
//           },
//           {
//             id: "access_documents_download",
//             key: "download",
//             label: "Download",
//             description: "Download documents",
//           },
//           {
//             id: "access_documents_edit",
//             key: "edit",
//             label: "Edit",
//             description: "Edit document properties",
//           },
//           {
//             id: "access_documents_delete",
//             key: "delete",
//             label: "Delete",
//             description: "Delete documents",
//           },
//           {
//             id: "access_documents_share",
//             key: "share",
//             label: "Share",
//             description: "Share documents with others",
//           },
//         ],
//         excludePaths: [
//           "/dashboard/documents/trash",
//           "/dashboard/documents/versions",
//         ],
//       },
//       {
//         id: "feature_document_templates",
//         path: "/dashboard/documents/templates",
//         mText: "Templates",
//         sidebarId: "sidebar_document_templates",
//         description: "Manage document templates",
//         permissions: [
//           {
//             id: "access_document_templates_create",
//             key: "create",
//             label: "Create Templates",
//             description: "Create new document templates",
//           },
//           {
//             id: "access_document_templates_edit",
//             key: "edit",
//             label: "Edit Templates",
//             description: "Edit existing templates",
//           },
//         ],
//       },
//     ],
//     sidebarId: "sidebar_documents",
//     description: "Document management system",
//     featureName: "Document Management",
//   },
//   {
//     id: "feature_settings",
//     path: "/dashboard/settings",
//     mText: "Settings",
//     subMenu: [
//       {
//         id: "feature_settings_profile",
//         mText: "Profile Information",
//         sidebarId: "sidebar_profile",
//         path: "/dashboard/settings/profile",
//         category: "Account Settings",
//         permissions: [
//           {
//             id: "access_settings_profile_view",
//             key: "view",
//             label: "View Profile",
//             description: "View your profile information",
//           },
//           {
//             id: "access_settings_profile_edit",
//             key: "edit",
//             label: "Edit Profile",
//             description: "Update your name, email, and other details",
//           },
//           {
//             id: "access_settings_profile_avatar",
//             key: "upload_avatar",
//             label: "Upload Avatar",
//             description: "Upload or change your profile picture",
//           },
//         ],
//       },
//       {
//         id: "feature_settings_change_password",
//         mText: "Change Password",
//         sidebarId: "sidebar_change_password",
//         path: "/dashboard/settings/change-password",
//         category: "Account Settings",
//         permissions: [
//           {
//             id: "access_settings_change_password",
//             key: "change_password",
//             label: "Change Password",
//             description: "Update or reset your password",
//           },
//         ],
//       },
//       {
//         id: "feature_settings_firm_profile",
//         mText: "Firm Profile",
//         sidebarId: "sidebar_firm_profile",
//         path: "/dashboard/settings/firm-profile",
//         category: "Firm & Users",
//         permissions: [
//           {
//             id: "access_settings_firm_view",
//             key: "view_firm_profile",
//             label: "View Firm Profile",
//             description: "View firm information and branding",
//           },
//           {
//             id: "access_settings_firm_edit",
//             key: "edit_firm_profile",
//             label: "Edit Firm Profile",
//             description: "Edit firm details like name, address, etc.",
//           },
//           {
//             id: "access_settings_firm_logo",
//             key: "upload_firm_logo",
//             label: "Upload Firm Logo",
//             description: "Upload or change firm logo",
//           },
//         ],
//       },
//       {
//         id: "feature_users_roles",
//         path: "/dashboard/settings/users-roles",
//         mText: "Users & Roles",
//         sidebarId: "sidebar_users_roles",
//         permissions: [
//           {
//             id: "access_invite_user_button",
//             key: "invite",
//             label: "Invite Users",
//             description: "Invite new users",
//           },
//           {
//             id: "access_delete_user_button",
//             key: "delete_user",
//             label: "Delete Users",
//             description: "Delete existing users",
//           },
//           {
//             id: "access_delete_role_button",
//             key: "delete_role",
//             label: "Delete Roles",
//             description: "Delete roles",
//           },
//         ],
//       },
//       {
//         id: "feature_settings_subscription",
//         mText: "Subscription & Billing",
//         sidebarId: "sidebar_subscription_billing",
//         path: "/dashboard/settings/subscription-billing",
//         category: "Firm & Users",
//         permissions: [
//           {
//             id: "access_subscription_view",
//             key: "view_subscription",
//             label: "View Subscription",
//             description: "View current plan and usage",
//           },
//           {
//             id: "access_subscription_change_plan",
//             key: "change_plan",
//             label: "Change Plan",
//             description: "Upgrade or downgrade subscription plan",
//           },
//           {
//             id: "access_subscription_update_billing",
//             key: "update_billing_info",
//             label: "Update Billing Info",
//             description: "Manage payment method and billing details",
//           },
//           {
//             id: "access_subscription_cancel",
//             key: "cancel_subscription",
//             label: "Cancel Subscription",
//             description: "Cancel active subscription",
//           },
//           {
//             id: "access_subscription_invoices_view",
//             key: "view_invoices",
//             label: "View Invoices",
//             description: "See invoice history",
//           },
//           {
//             id: "access_subscription_invoices_download",
//             key: "download_invoices",
//             label: "Download Invoices",
//             description: "Download invoice PDFs",
//           },
//         ],
//       },
//       {
//         id: "feature_settings_theme",
//         mText: "Theme Customization",
//         sidebarId: "sidebar_theme_customization",
//         path: "/dashboard/settings/theme-customization",
//         category: "Customization",
//         permissions: [
//           {
//             id: "access_theme_view",
//             key: "view_theme",
//             label: "View Theme",
//             description: "View current theme options",
//           },
//           {
//             id: "access_theme_edit",
//             key: "edit_theme",
//             label: "Edit Theme",
//             description: "Customize theme colors and appearance",
//           },
//           {
//             id: "access_theme_reset",
//             key: "reset_theme",
//             label: "Reset Theme",
//             description: "Reset theme to defaults",
//           },
//         ],
//       },
//       {
//         id: "feature_settings_form_templates",
//         mText: "Form Layout & Custom Fields",
//         sidebarId: "sidebar_form_templates",
//         path: "/dashboard/settings/form-templates",
//         category: "Customization",
//         permissions: [
//           {
//             id: "access_custom_fields_create",
//             key: "create_custom_field",
//             label: "Create Field",
//             description: "Create a new custom field",
//           },
//           {
//             id: "access_custom_fields_edit",
//             key: "edit_custom_field",
//             label: "Edit Field",
//             description: "Edit existing custom fields",
//           },
//           {
//             id: "access_custom_fields_delete",
//             key: "delete_custom_field",
//             label: "Delete Field",
//             description: "Delete custom fields",
//           },
//           {
//             id: "access_form_layout_reorder",
//             key: "reorder_form_layout",
//             label: "Reorder Layout",
//             description: "Reorder and arrange form sections",
//           },
//           {
//             id: "access_form_template_export",
//             key: "export_form_template",
//             label: "Export",
//             description: "Export form template configuration",
//           },
//           {
//             id: "access_form_template_import",
//             key: "import_form_template",
//             label: "Import",
//             description: "Import form template configuration",
//           },
//         ],
//       },
//     ],
//     sidebarId: "sidebar_settings",
//     description: "System settings and configuration",
//     featureName: "Settings & User Management",
//     permissions: [
//       {
//         id: "access_settings_edit",
//         key: "edit",
//         label: "Edit Settings",
//         description: "Edit system settings",
//       },
//       {
//         id: "access_settings_user_management",
//         key: "user_management",
//         label: "User Management",
//         description: "Manage users and permissions",
//       },
//       {
//         id: "access_settings_system_config",
//         key: "system_config",
//         label: "System Configuration",
//         description: "Configure system-wide settings",
//       },
//     ],
//     excludePaths: ["/dashboard/settings/advanced", "/dashboard/settings/logs"],
//   },
// ];
